import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils/classnames.js';
function Skeleton({ height, width, borderRadius, shape = 'squared', className, }) {
    return (_jsx("div", { className: cn('ui-animate-pulse ui-bg-gray-200 theme-dark:ui-bg-neutral-600', shape === 'circle' && 'ui-rounded-full', !width && 'ui-w-full', className), style: {
            height: `${height}px`,
            width: width && `${width}px`,
            ...(shape === 'squared' && {
                borderRadius: borderRadius ?? `${height / 4}px`,
            }),
        } }));
}
export default Skeleton;
